module.exports = __webpack_public_path__ + "static/img/p_home_server.fc437690.jpg";